import { useCallback, useState } from 'react';
import { usePayment } from '../context/PaymentContext';

export const useCreditCardPayment = () => {
  const {
    amountToPayWithCreditCard,
    setAmountCreditCard,
    getMaxAmounts,
    loading,
    calculateRemainingPrice,
    setSelectedPaymentMethod,
  } = usePayment();

  const [creditCardData, setCreditCardData] = useState(null);

  const handleCreditCardDataChange = useCallback((data) => {
    setCreditCardData(data);
  }, []);

  const handleAmountChange = useCallback((value, combinePayment, totalPrice) => {
    const maxAmounts = getMaxAmounts();
    let validValue = 0;
    if (combinePayment) {
      validValue = value && value > 0 ? Math.min(parseFloat(value), maxAmounts.maxCreditCard) : 0;
    } else {
      validValue = totalPrice;
    }
    setAmountCreditCard(validValue);
    if (!combinePayment) {
      if (validValue > 0) {
        setSelectedPaymentMethod("creditCard");
      } else {
        setSelectedPaymentMethod(null);
      }
    }
  }, [setAmountCreditCard, getMaxAmounts, setSelectedPaymentMethod]);

  const canProceed = useCallback(() => {
    const remaining = calculateRemainingPrice();
    return amountToPayWithCreditCard > 0 ? remaining === 0 && creditCardData !== null : true;
  }, [amountToPayWithCreditCard, calculateRemainingPrice, creditCardData]);

  const clearCreditCardPayment = useCallback(() => {
    setCreditCardData(prevData => prevData !== null ? null : prevData);
    setAmountCreditCard(0);
  }, [setAmountCreditCard]);

  return {
    creditCardData,
    amountToPayWithCreditCard,
    maxAmount: getMaxAmounts().maxCreditCard,
    loading,
    handleCreditCardDataChange,
    handleAmountChange,
    canProceed,
    clearCreditCardPayment,
  };
};
